import { z } from "zod";

// Leaf module: the generation-state enum is consumed by the Drizzle schema
// (`@kuzco/db` pgEnum), which must not drag `generations.models.ts` and its
// OpenAI schema graph into every DB client's module graph.
export const GENERATION_STATES = [
  "Queued",
  "In Progress",
  "Success",
  "Failed",
  // Terminal state for client-cancelled generations. Unlike Failed it can
  // carry a charge: tokens generated up to the disconnect are billed when the
  // deployment opts in via enable_incremental_usage_billing.
  "Cancelled",
] as const;

export const GenerationStateSchema = z.enum(GENERATION_STATES);

export type GenerationState = z.infer<typeof GenerationStateSchema>;

/**
 * States a generation never moves out of. A reader that needs the finalized
 * outcome of a generation — token counts, charge, terminal error — has to
 * wait until the state is one of these.
 */
export const TERMINAL_GENERATION_STATES = new Set<string>([
  "Success",
  "Failed",
  "Cancelled",
] satisfies GenerationState[]);
